<template>
  <div>
    <b-form @submit="onSubmit">
      <div class="contents course-edit">
        <div class="row border-top-dgray border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{ $t("title.common.course") }}</label>
          </div>
          <div class="col-md-9">
            <input type="text" v-model="form.coursename" required />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{ $t("title.common.code") }}</label>
          </div>
          <div class="col-md-9">
            <input
              type="text"
              v-model="form.coursecode"
              required
              maxlength="6"
              :placeholder="$t('text.golfcourse.golfcourse_code_placeholder')"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{ $t("title.common.hole") }}</label>
          </div>
          <div class="col-md-9">
            <input
              type="text"
              required
              placeholder="18"
              v-model="form.holesum"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.par_count")
            }}</label>
          </div>
          <div class="col-md-9">
            <input
              type="text"
              required
              placeholder="72"
              v-model="form.parsum"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.subcourse_count")
            }}</label>
          </div>
          <div class="col-md-9">
            <select
              class="form-select-lg"
              v-model="form.subcourselistcnt"
              @change="input_subcoursecnt($event)"
            >
              <template v-for="(bnt, index) in subcoursecnt">
                <option :value="bnt" :key="index + 'r'">{{ bnt }}</option>
              </template>
            </select>
          </div>
        </div>

        <div v-for="(anc, index) in subcoursecnt" :key="index">
          <div
            class="row border-bottom"
            v-if="index < form.subcourselistcnt"
          >
            <input type="hidden" v-model="form.subcourse.type_fk[index]" />
            <div class="col-md bg-gray row align-items-center">
              <label class="d-table-cell"
                >{{ $t("title.golfcourse.sub_course") }} {{ anc }}</label
              >
            </div>
            <div class="col-md-9">
              <input
                type="text"
                required
                placeholder=""
                v-model="form.subcourse.subcoursename[index]"
                class="mb-3"
              />

              <b-table-simple small bordered responsive table-class="hole-info">
                <b-tbody>
                  <b-tr>
                    <b-th sticky-column class="border-end">{{ $t("title.common.hole") }}</b-th>
                    <b-td
                      v-for="(bnc, index2) in form.subcourse.subcoursehole[
                        index
                      ].hole"
                      :key="index2"
                      @click="showModal(bnc, anc)"
                      class="pointer"
                    >
                      {{ bnc }}
                    </b-td>
                    <b-td>
                      {{ $t("title.golfcourse.sum") }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th sticky-column class="border-end">{{ $t("title.common.par") }}</b-th>
                    <b-td
                      v-for="(cnc, index3) in form.subcourse.subcoursehole[
                        index
                      ].par"
                      :key="index3"
                    >
                      <input
                        type="text"
                        v-model="
                          form.subcourse.subcoursehole[index].par[index3]
                        "
                        required
                      />
                    </b-td>
                    <b-td>
                      <input
                        type="text"
                        v-model="form.subcourse.subcourseparsum[index]"
                        required
                      />                      
                    </b-td>
                  </b-tr>                  
                  <b-tr>
                    <b-th sticky-column class="border-end">{{ $t("title.common.handicap") }}</b-th>
                    <b-td
                      v-for="(cnc, index4) in form.subcourse.subcoursehole[
                        index
                      ].handicap"
                      :key="index4"
                    >
                      <input
                        type="text"
                        v-model="
                          form.subcourse.subcoursehole[index].handicap[index4]
                        "
                        required
                      />
                    </b-td>
                    <b-td>
                      <input type="text" value="-" />
                    </b-td>
                  </b-tr>                  
                </b-tbody>
              </b-table-simple>              
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.course_image")
            }}</label>
          </div>
          <div class="col-md-9">
            <div class="input-group">
              <input
                type="text"
                class="form-control text-truncate"
                :value="filename_"
                :placeholder="$t('text.common.no_file_chosen')"
              />
              <button
                type="button"
                class="btn btn-primary btn-lg icon-attachment"
                @click="$refs.file.click()"
              >
                {{ $t("button.common.choose_file") }}
                <input
                  type="file"
                  ref="file"
                  @change="fileSelect()"
                  class="d-none"
                />
              </button>
            </div>
            <article class="article-attach" v-if="form.originname">
              <a :href="form.filename | get_img">
                <i class="material-icons-outlined">file_download</i>
                <span>{{ form.originname }}</span>
              </a>
            </article>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.course_use")
            }}</label>
          </div>
          <div class="col-md-9">
            <div class="d-flex flex-column flex-md-row my-2">
              <div class="my-1 pe-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexCheck1"
                    v-model="form.status"
                    true-value="0"
                    false-value="1"
                  />
                  <label
                    class="form-check-label"
                    for="flexCheck1"
                    >{{ $t("text.common.use") }}</label
                  >
                </div>
              </div>
              <div class="my-1 pe-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexCheck2"
                    v-model="form.viewflag"
                    true-value="1"
                    false-value="0"
                  />
                  <label
                    class="form-check-label"
                    for="flexCheck2"
                    >{{ $t("text.golfcourse.check_view_hole") }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.difficulty")
            }}</label>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-6 mb-2 mb-md-0 pe-md-1">
                <select class="form-select-lg" v-model="form.field" required>
                  <option value="">
                    {{ $t("filter.golfcourse.course") }}
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>

              <div class="col-md-6 ps-md-1">
                <select class="form-select-lg" v-model="form.green" required>
                  <option value="">
                    {{ $t("filter.golfcourse.green") }}
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell"
              >{{ $t("title.golfcourse.city") }}/{{
                $t("title.golfcourse.state")
              }}</label
            >
          </div>
          <div class="col-md-9">
            <input type="text" v-model="form.area" required />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.golfcourse.country")
            }}</label>
          </div>
          <div class="col-md-9">
            <select class="form-select-lg" v-model="form.country" required>
              <option
                v-for="(country, index) in countrylist"
                :key="index + 'c'"
                :value="country.countryno"
              >
                {{ country.countryname }}
              </option>
            </select>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-md bg-gray row align-items-center">
            <label class="d-table-cell">{{
              $t("title.common.description")
            }}</label>
          </div>
          <div class="col-md-9">
            <textarea
              v-model="form.contents"
              cols="30"
              rows="10"
              :placeholder="$t('text.event.description_course')"
              required
            ></textarea>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="$router.push({ name: 'CourseList' })"
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('button.common.save')"
            type="submit"
            >{{ $t("button.common.save") }}</b-button
          >
        </div>
      </div>
    </b-form>

    <b-modal
      id="modal-hole-edit"
      ref="modal-hole-edit"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.golfcourse.course_hole_register") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="hideModal"
        ></b-button>
      </template>
      <b-form @submit="onHoleSubmit">
        <div class="hor-type border-top-dgray">
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell"
                >{{ $t("title.golfcourse.golfcourse") }}
                {{ $t("title.common.name") }}</label
              >
            </div>
            <div class="col-lg lh-sm">
              <p>{{ hole_form.coursename }}</p>
            </div>
          </div>

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell"
                >{{ $t("title.golfcourse.subcourse") }}
                {{ $t("title.common.name") }}</label
              >
            </div>
            <div class="col-lg lh-sm">
              <p>{{ hole_form.subcoursename }}</p>
            </div>
          </div>

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">{{ $t("title.common.hole") }}</label>
            </div>
            <div class="col-lg lh-sm">
              <p>{{ hole_form.holeno }}H</p>
            </div>
          </div>

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">{{
                $t("title.golfcourse.golfcourse_minimap")
              }}</label>
            </div>
            <div class="col-lg lh-sm">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control text-truncate"
                  :value="m_file1_"
                  :placeholder="$t('text.common.no_file_chosen')"
                />
                <button
                  type="button"
                  class="btn btn-primary btn-lg icon-attachment"
                  @click="$refs.m_file1.click()"
                >
                  {{ $t("button.common.choose_file") }}
                  <input
                    type="file"
                    ref="m_file1"
                    @change="fileSelect_m(1)"
                    class="d-none"
                  />
                </button>
              </div>
              <p class="text-subscript mt-2" v-if="courseholeview.minimap_name">
                {{ courseholeview.minimap_name }}
              </p>
              <!-- <img
                :src="courseholeview.minimap_url"
                class="mw-100 h_250"
              /> -->
            </div>
          </div>

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">{{
                $t("title.golfcourse.green_minimap_left")
              }}</label>
            </div>
            <div class="col-lg lh-sm">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control text-truncate"
                  :value="m_file2_"
                  :placeholder="$t('text.common.no_file_chosen')"
                />
                <button
                  type="button"
                  class="btn btn-primary btn-lg icon-attachment"
                  @click="$refs.m_file2.click()"
                >
                  {{ $t("button.common.choose_file") }}
                  <input
                    type="file"
                    ref="m_file2"
                    @change="fileSelect_m(2)"
                    class="d-none"
                  />
                </button>
              </div>
              <p class="text-subscript mt-2" v-if="courseholeview.grnmap1_name">
                {{ courseholeview.grnmap1_name }}
              </p>
              <!-- <img
                :src="courseholeview.grnmap1_url"
                class="mw-100 h_250"
              /> -->
            </div>
          </div>

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">{{
                $t("title.golfcourse.green_minimap_right")
              }}</label>
            </div>
            <div class="col-lg lh-sm">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control text-truncate"
                  :value="m_file3_"
                  :placeholder="$t('text.common.no_file_chosen')"
                />
                <button
                  type="button"
                  class="btn btn-primary btn-lg icon-attachment"
                  @click="$refs.m_file3.click()"
                >
                  {{ $t("button.common.choose_file") }}
                  <input
                    type="file"
                    ref="m_file3"
                    @change="fileSelect_m(3)"
                    class="d-none"
                  />
                </button>
              </div>
              <p class="text-subscript mt-2" v-if="courseholeview.grnmap2_name">
                {{ courseholeview.grnmap2_name }}
              </p>
              <!-- <img
                :src="courseholeview.grnmap2_url"
                class="mw-100 h_250"
              /> -->
            </div>
          </div>

          <!-- <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">{{
                $t("title.golfcourse.hole_video")
              }}</label>
            </div>
            <div class="col-lg lh-sm">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control text-truncate"
                  :value="filename_"
                  :placeholder="$t('text.common.no_file_chosen')"
                />
                <button
                  type="button"
                  class="btn btn-primary btn-lg icon-attachment"
                  @click="$refs.file.click()"
                >
                  {{ $t("button.common.choose_file") }}
                  <input
                    type="file"
                    ref="m_file4"
                    @change="fileSelect_m(4)"
                    class="d-none"
                  />
                </button>
              </div>
              <p class="text-subscript mt-2">{{
                courseholeview.movie_name
              }}</p>
            </div>
          </div> -->

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">{{
                $t("title.golfcourse.hole_memo")
              }}</label>
            </div>
            <div class="col-lg d-flex">
              <textarea
                v-model="hole_form.contents"
                cols="30"
                rows="10"
                class="align-self-stretch"
              ></textarea>
            </div>
          </div>
        </div>
      </b-form>

      <template #modal-footer>
        <b-button
          type="button"
          class="btn btn-outline-secondary btn-md"
          :aria-label="$t('button.common.close')"
          @click="hideModal"
        >
          {{ $t("button.common.close") }}
        </b-button>
        <b-button
          type="submit"
          class="btn btn-secondary btn-md"
          :aria-label="$t('button.common.submit')"
        >
          {{ $t("button.common.submit") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/course";
import ax2 from "@/api/member";
import i18n from "@/i18n";
export default {
  name: "CourseWrite",
  name: "CourseEdit",
  data() {
    return {
      courseno: this.$route.params.courseno || "",
      form: {
        coursename: "",
        coursecode: "",
        holesum: "",
        parsum: "",
        subcourselistcnt: "2",
        subcourse: {
          subcourseseq: [],
          type_fk: [],
          subcoursename: [],
          subcourseparsum: [],
          subcoursehole: [
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              hole: [1, 2, 3, 4, 5, 6, 7, 8, 9],
              par: [0, 0, 0, 0, 0, 0, 0, 0, 0],
              handicap: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        filename: "",
        status: "0",
        viewflag: "",
        field: "",
        green: "",
        country: "",
        area: "",
        contents: "",
        path: "",
        image: "",
      },
      filename_: "",
      m_file1_: "",
      m_file2_: "",
      m_file3_: "",
      subcoursecnt: [1, 2, 3, 4],
      subcourselist: [],
      hole_form: {
        courseno: "",
        coursubtype: "",
        coursename: "",
        subcoursename: "",
        holeno: 0,
        minimap: "",
        grnmap1: "",
        grnmap2: "",
        movie: "",
        contents: "",
        mode: "write",
      },

      courseholeview: [
        {
          subcoursename: "",
          par: "",
          minimap_name: "",
          grnmap1_name: "",
          grnmap2_name: "",
          movie_name: "",
          minimap_url: "",
          grnmap1_url: "",
          grnmap2_url: "",
          movie_url: "",
          contents: "",
        },
      ],

      countrylist: [],
      tempstop: "stop",
    };
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      if (this.tempstop == "stop") {
        alert(this.$i18n.t("alert.common.temp_stop"));
        return false;
      }

      if (!this.check_coursecode(this.form.coursecode)) {
        alert(this.$i18n.t("alert.golfcourse.according_rules"));
      }

      let formData = new FormData();
      formData.append("coursename", this.form.coursename);
      formData.append("coursecode", this.form.coursecode);
      formData.append("holesum", this.form.holesum);
      formData.append("parsum", this.form.parsum);
      formData.append("subcourselistcnt", this.form.subcourselistcnt);

      //alert(this.form.subcourse.subcoursehole)
      for (let i = 0; i < this.form.subcourselistcnt; i++) {
        formData.append(
          "subcourseseq[" + i + "]",
          this.form.subcourse.subcourseseq[i]
        );
        formData.append("type_fk[" + i + "]", this.form.subcourse.type_fk[i]);
        formData.append(
          "subcoursename[" + i + "]",
          this.form.subcourse.subcoursename[i]
        );
        formData.append(
          "subcourseparsum[" + i + "]",
          this.form.subcourse.subcourseparsum[i]
        );

        for (let j = 0; j < 9; j++) {
          formData.append(
            "hole[" + i + "][" + j + "]",
            this.form.subcourse.subcoursehole[i].hole[j]
          );
          formData.append(
            "par[" + i + "][" + j + "]",
            this.form.subcourse.subcoursehole[i].par[j]
          );
          formData.append(
            "handicap[" + i + "][" + j + "]",
            this.form.subcourse.subcoursehole[i].handicap[j]
          );
        }
      }

      formData.append("filename", this.form.filename);
      // this.form.status = this.form.status ? 1 : 0
      formData.append("status", this.form.status);
      // this.form.viewflag = this.form.viewflag ? 1 : 0
      formData.append("viewflag", this.form.viewflag);
      formData.append("field", this.form.field);
      formData.append("green", this.form.green);
      formData.append("country", this.form.country);
      formData.append("area", this.form.area);
      formData.append("contents", this.form.contents);

      formData.entries();
      const _this = this;

      ax.set_admincourseedit(this.courseno, formData, function (flag, data) {
        console.log(flag, data);
        if (flag) {
          alert(data.message);
          _this.$router.push({ name: "CourseList" });
        } else {
          alert(data);
        }
      });
    },
    input_subcoursecnt(event) {
      ax.post_subcoursecntcheck(
        this.courseno,
        event.target.value,
        (flag, data) => {
          if (!flag) {
            alert(data.message);
            return false;
          }
        }
      );
      // this.subcourselistcnt = event.target.value;
    },
    fileSelect() {
      this.filename_ = this.$refs.file.files[0].name;
      this.form.filename = this.$refs.file.files[0];
    },
    get_courseview() {
      ax.get_admincourseview(this.courseno, (flag, data) => {
        if (flag) {
          this.form.coursename = data.coursebasicinfo.coursename;
          this.form.coursecode = data.coursebasicinfo.coursecode;
          this.form.holesum = data.coursebasicinfo.holesum;
          this.form.parsum = data.coursebasicinfo.parsum;
          this.form.subcourselistcnt = data.subcourse.length;
          this.form.subcourselist = data.subcourse;
          // this.subcourselistcnt = data.subcoursecnt

          // alert(data.subcourse.subcoursename)
          data.subcourse.forEach((v, i) => {
            this.form.subcourse.subcoursename[i] = data.subcourse[i].title;
            this.form.subcourse.subcourseseq[i] =
              data.subcourse[i].subcourseseq;
            this.form.subcourse.type_fk[i] = data.subcourse[i].type_fk;
            this.form.subcourse.subcourseparsum[i] =
              data.subcourse[i].subparcnt;
            v.subcoursehole.forEach((v_, j) => {
              this.form.subcourse.subcoursehole[i].hole[j] = v_.hole_no;
              this.form.subcourse.subcoursehole[i].par[j] = v_.par_score;
              this.form.subcourse.subcoursehole[i].handicap[j] = v_.handicap;
            });
          });
          this.form.status = data.coursebasicinfo.status;
          this.form.viewflag = data.coursebasicinfo.viewflag;
          this.form.field = data.coursebasicinfo.field;
          this.form.green = data.coursebasicinfo.green;
          this.form.country = data.coursebasicinfo.country;
          this.form.area = data.coursebasicinfo.area;
          this.form.contents = data.coursebasicinfo.contents;
          this.form.course_image_url = data.coursebasicinfo.course_image_url;
          this.form.originname = data.coursebasicinfo.originname;
        } else {
          alert(data);
        }
      });
    },
    showModal(hole, type) {
      this.hole_form.courseno = this.courseno;
      this.hole_form.coursename = this.form.coursename;
      this.hole_form.coursubtype = type;
      this.hole_form.holeno = hole;

      this.hole_form.minimap = "";
      this.m_file1_ = "";
      this.hole_form.grnmap1 = "";
      this.m_file2_ = "";
      this.hole_form.grnmap2 = "";
      this.m_file3_ = "";

      ax.get_admincourseholeview(this.courseno, hole, type, (flag, data) => {
        if (flag) {
          this.hole_form.subcoursename = data.courseholeview.subcoursename;
          this.hole_form.contents = data.courseholeview.contents;
          this.hole_form.mode = "edit";
          this.courseholeview = data.courseholeview;
          console.log(this.courseholeview);
        } else {
          this.hole_form.contents = "";
          this.hole_form.mode = "write";
          this.courseholeview = data.courseholeview;
        }
        //this.$refs["modal-hole-edit"].modalOuterStyle.zIndex = 9999;
        this.$refs["modal-hole-edit"].show();
      });
    },
    hideModal() {
      this.$refs["modal-hole-edit"].hide();
    },

    fileSelect_m(type) {
      if (type === 1) {
        this.hole_form.minimap = this.$refs.m_file1.files[0];
        this.m_file1_ = this.$refs.m_file1.files[0].name;
      } else if (type === 2) {
        this.hole_form.grnmap1 = this.$refs.m_file2.files[0];
        this.m_file2_ = this.$refs.m_file2.files[0].name;
      } else if (type === 3) {
        this.hole_form.grnmap2 = this.$refs.m_file3.files[0];
        this.m_file3_ = this.$refs.m_file3.files[0].name;
      }
    },
    onHoleSubmit(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("courseno", this.hole_form.courseno);
      formData.append("coursubtype", this.hole_form.coursubtype);
      formData.append("holeno", this.hole_form.holeno);
      formData.append("minimap", this.hole_form.minimap);
      formData.append("grnmap1", this.hole_form.grnmap1);
      formData.append("grnmap2", this.hole_form.grnmap2);
      if (this.hole_form.mode === "write")
        formData.append("movie", this.hole_form.movie);
      else formData.append("movie", this.hole_form.movie);
      formData.append("contents", this.hole_form.contents);

      formData.entries();
      if (this.hole_form.mode === "write") {
        ax.set_admincourseholewrite(formData, function (flag, data) {
          console.log(flag, data);
          alert(data.message);
        });
      } else {
        ax.set_admincourseholeedit(formData, function (flag, data) {
          console.log(flag, data);
          alert(data.message);
        });
      }
    },
    check_coursecode(code) {
      let re = /([C,D]_\d{4})/;
      return re.test(code);
    },
    get_countrylist() {
      ax2.get_countrylist((flag, data) => {
        if (flag) {
          this.countrylist = data.countrylist;
        } else {
          alert(data);
        }
      });
    },
  },
  mounted() {
    this.get_courseview();
    this.get_countrylist();
  },
};
</script>